/**
 * @param {Array} jobs
 * @param {boolean} rowsDisabled
 * @param {boolean=false} hasDuration
 * @param {boolean=false} hasAutoLogin
 * @param {string="type"} iconField
 * @param {function(Object): string} [accountLabel] - see columns.js
 * @param {{header: string, render: function(Object): ReactNode}} [secondaryColumn] - see columns.js
 */
import React from "react";
import TableRow from "./TableRow";
import { accountLabelByPlan, emailColumn } from "./columns";
import styles from "./QueueJobsPage.module.scss";

const QueueJobsTable = ({
  jobs,
  rowsDisabled,
  hasDuration = false,
  hasAutoLogin = false,
  iconField = "type",
  accountLabel = accountLabelByPlan,
  secondaryColumn = emailColumn,
}) => {
  const durationCol = hasDuration ? <col className={styles.colDuration} /> : null;
  const durationHeader = hasDuration ? <th scope="col">Duration</th> : null;

  const rows = jobs.map((job) => (
    <TableRow
      key={job.id}
      job={job}
      disabled={rowsDisabled}
      hasDuration={hasDuration}
      hasAutoLogin={hasAutoLogin}
      iconField={iconField}
      accountLabel={accountLabel}
      secondaryColumn={secondaryColumn}
    />
  ));

  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <colgroup>
          <col />
          <col className={styles.colId} />
          <col className={styles.colCreated} />
          <col />
          <col className={styles.colStatus} />
          {durationCol}
          <col className={styles.colActions} />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">Account</th>
            <th scope="col">Id</th>
            <th scope="col">Created</th>
            <th scope="col">{secondaryColumn.header}</th>
            <th scope="col">Status</th>
            {durationHeader}
            <th scope="col" aria-hidden="true" />
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

export default QueueJobsTable;
